import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-adddeliverytype',
  templateUrl: './adddeliverytype.component.html',
  styleUrls: ['./adddeliverytype.component.css']
})
export class AdddeliverytypeComponent implements OnInit {

//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

//Save Validation
submitted:boolean;
successfully:boolean;


//Edit Get Values
deliverytypeColl:any=[];
deliverytypeid:number=0

deliverytypeform=new FormGroup({
  deliverytype:new FormControl('',Validators.required),         
  deliverytypeid:new FormControl(0),      
 inactive:new FormControl(false),     
});

isloading:boolean=false;
isprivilage:boolean=false;  
showProgress:boolean=false;
formname:String="DeliveryType";

_routerSub = Subscription.EMPTY;
_routerparamsSub = Subscription.EMPTY;
_routerLoginSub = Subscription.EMPTY

constructor(private appService: DhukanDataService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService,private loginService:LoginDataService) { 
    this._routerSub = this.route.queryParams.subscribe(params => {
      if(params.id!==undefined){
        this.deliverytypeid = params.id
      }  

     });

     this.fnServiceChanges();
}


fnServiceChanges(){
  this._routerLoginSub = this.loginService.serviceloginChange.subscribe((value) => {
        if(this.loginService.fnCheckUser()){
         
          if(this.fnCheckUserPririvilage()){
            this.isloading=true;
            this.fnOnInitForm();
          }
          else{
            this.fnUserFailedForm();
          }
            
        }
        else{
          this.fnUserFailedForm();
        }
  });
}

ngOnInit() {
    try{
      if(this.loginService.fnCheckUser()){ 
        if(this.fnCheckUserPririvilage()){       
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }
      }
      else{
        this.loginService.fnGetUserRoleList();
      }
              
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
}
ngOnDestroy(): void {
  if (this._routerSub !== undefined) {
    this._routerSub.unsubscribe();
  }
  if (this._routerparamsSub !== undefined) {
    this._routerparamsSub.unsubscribe();
  }

  if (this._routerLoginSub !== undefined) {
    this._routerLoginSub.unsubscribe();
  }
}
fnOnInitForm(){
   try{
       this.isaddmode=true;
       this.deliverytypeform.reset();
       this.fnInitializeDeliveryTypeFormGroup(); 

       if(this.deliverytypeid>0){
         this.fngetDeliveryType();
       }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}



fnCheckUserPririvilage(){
  var _check:boolean=false;
  if (this.deliverytypeid>0){
    _check= this.loginService.fnCheckUserRoleAction(this.formname,'ALTER')
  }else{
    _check= this.loginService.fnCheckUserRoleAction(this.formname,'CREATE')
  }

  return _check;
}

fnUserFailedForm(){
  this.isprivilage=true;
}

fnInitializeDeliveryTypeFormGroup(){
   this.deliverytypeform.setValue({
    deliverytype:'',
    deliverytypeid:0,      
     inactive:false,      
   })
}

//Get 
fngetDeliveryType() {        
     var data = {
       'deliverytypeid':this.deliverytypeid,            
     }
     this.appService.getDeliveryType(data)
     .subscribe(
       (res)=>{                  
         this.deliverytypeColl=res.json().result;
         var editdata = {
           'deliverytypeid':this.deliverytypeColl[0].deliverytypeid,
           'deliverytype':this.deliverytypeColl[0].deliverytype, 
           'inactive':this.deliverytypeColl[0].inactive,          
         }
         this.fnEditMode(editdata);
     },
     (err)=>{          
       this.toastr.error('Error', err);
     })
}

//Save Btn Click
fnSaveBtnClick(){
   try{
     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.deliverytypeform.valid){
         //Check
         var data = {
               'deliverytypeid': this.deliverytypeid,       
               'deliverytype':this.deliverytypeform.get('deliverytype').value,            
               'inactive': 0,  
               'createdby': this.loginService.fnGetModUserId(),    
               'modifiedby':this.loginService.fnGetModUserId(), 
         }
         this.appService.fnCheckDeliveryType(data).subscribe(
           (res)=>{
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.deliverytypeform.get('deliverytypeid').value>0){
                       //Update Department
                       this.fnSetDeliveryType(data);
                     }
                     else{
                       //Insert Department
                       this.fnInsertDeliveryType(data);
                     }
               }
               else{        
                     if(_checkresult==="name"){
                       this.deliverytypeform.controls['deliverytype'].setErrors({'notfound': true});
                     }
               }
         },
         (err)=>{
             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertDeliveryType(data){    
 
   this.appService.fnInsertDeliveryType(data).subscribe(
     (res)=>{
     if(res.json().result!=""){
       this.toastr.success('', "The new deliverytype has been added successfully.Insert Successfully");

       this.fnInsertActivityLog('INSERT',0,data.deliverytype);

       this.fnCloseDeliveryType();
     }},
     (err)=>{
       this.toastr.error('Error', err);
     });

}

//Set
fnSetDeliveryType(data){    

this.appService.fnSetDeliveryType(data).subscribe(
 (res)=>{
 if(res.json().result!=""){
     this.toastr.success('', "The deliverytype has been updated successfully.");

     this.fnInsertActivityLog('EDIT',this.deliverytypeid,data.deliverytype);

     this.fnCloseDeliveryType();        
 }},
 (err)=>{
   this.toastr.error('Error', err);
 });

}

//Close
fnCloseDeliveryType(){
try{
  this.router.navigate(['/DeliveryType']);
}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
 this.deliverytypeform.setValue({
  deliverytype:deptBO.deliverytype,
  deliverytypeid:deptBO.deliverytypeid,
   inactive:deptBO.inactive,   
 });

this.isaddmode=false;
this.iseditmode=true;
this.isdeletemode=false;
this.isviewmode=false;
}



fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}


private fnShowProgress(){
  this.showProgress=true;
}
private fnHideProgress(){
  this.showProgress=false;
}

private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}



}
